<!-- 结算后订单收入 -->
<template>
  <div class="container">
    <div class="mainFooter">
      <div class="left">查询关键词：</div>
      <el-input
        size="small"
        style="width: 1.7rem; margin-right: 0.1rem"
        placeholder="请输入子订单编号"
      ></el-input>
      <el-date-picker
        size="small"
        style="margin-right: 0.1rem"
        type="daterange"
        range-separator="至"
        start-placeholder="消费日开始日期"
        end-placeholder="消费结束日期"
      >
      </el-date-picker>
      <el-input
        size="small"
        style="width: 1.7rem; margin-right: 0.1rem"
        placeholder="下单人名称/账号"
      ></el-input>
      <div class="zhi">
        <p>子订单金额：</p>
        <el-input style="width:0.5rem" size="small" type="text"></el-input>
        <p style="margin:0 0.05rem">元</p>
        <p style="margin:0 0.1 0 0.05rem">至</p>
        <el-input style="width:0.5rem"  size="small" type="text"></el-input>
        <p style="margin:0 0.05rem">元</p>
      </div>
      <div style="display: flex; align-items: center; margin-left: auto">
        <el-button style="color: #ed7046" size="small">重置</el-button>
        <el-button style="color: #ed7046" size="small">搜索</el-button>
      </div>
    </div>
    <p class="p3">
      符合条件共：订单（ <span>0个</span> ）金额（ <span>0¥</span> ）
    </p>
    <el-table
      border
      header-align="center"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column align="center" prop="orderNumber" label="子订单号">
      </el-table-column>
      <el-table-column align="center" prop="createName" label="下单人">
      </el-table-column>
      <el-table-column align="center" prop="address" label="结算日期">
        <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatHms }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="address" label="结算金额">
        <template slot-scope="scope">
            {{ scope.row.price + '¥' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props:{
    tableData:{
      type:Array,
      default:[]
    },
  },
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .zhi .el-input__inner {
  border: none !important;
}
.container {
  .zhi {
    padding: 0 0.1rem;
    color: #C1C4CB;
    background-color: #fff;
    font-size: 0.1rem;
    border-radius: 5px;
    display: flex;
    align-items: center;
    input {
      border: none !important;
      height: 32px;
      width: 0.5rem;
      text-align: center;
      margin: 0 0.05rem;
    }
  }
  .mainFooter {
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;
    background-color: #f3f3f3;
    padding: 0.15rem;
    .left {
      font-size: 0.12rem;
    }
  }
  .p3 {
    margin-bottom: 0.3rem;
    span {
      color: #dc7039;
      font-weight: bold;
    }
  }
}
</style>
